import type { ElementDefinition } from './types';

export function isElementSettings(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isElementDefinition(value: unknown): value is ElementDefinition {
    if (typeof value !== 'object' || value === null) {
        return false;
    }

    const maybeType = (value as { type?: unknown }).type;
    const maybeSettings = (value as { settings?: unknown }).settings;

    if (typeof maybeType !== 'string') {
        return false;
    }

    if (!isElementSettings(maybeSettings)) {
        return false;
    }

    return true;
}
